import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ExperienceModel } from './models/experience.model';
import { ExperienceCommentsModel } from './models/experience-comments.model';
import { ExperienceEvaluationsModel } from './models/experience-evaluations.model';
@Injectable({
  providedIn: 'root'
})
export class ExperienceService {

  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
     // 'Content-Type': 'application/json; charset=utf-8',
     // 'Authorization': "Bearer " + token,
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 getAll(): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Experience/GetAll`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
GetMyExperiences(): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Experience/GetMyExperiences`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
GetExperiencesByTravelerId(TravelerId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Experience/GetExperiencesByTravelerId/${TravelerId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

getById(Id:number): Observable<any> {

  return this.http
    .get<any>(`${this.baseUrl}Experience/GetById/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
insert(payload: ExperienceModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}Experience/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

update(payload: ExperienceModel): Observable<any> {
  return this.http
    .post<any>(`${this.baseUrl}Experience/Update`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

Comment(payload: ExperienceCommentsModel): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}Experience/Comment`, payload,this.httpOptions)
      .pipe(catchError((error: any) => throwError(error => error)));
  }
  Evaluate(payload: ExperienceEvaluationsModel): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}Experience/Evaluate`, payload,this.httpOptions)
      .pipe(catchError((error: any) => throwError(error => error)));
  }

delete(Id:number): Observable<any> {
  return this.http
    .get<any>(`${this.baseUrl}Experience/Delete/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

  deleteList(payload: ExperienceModel []): Observable<any> {
    console.log(JSON.stringify(payload))
    return this.http
      .post<any>(`${this.baseUrl}Experience/DeleteList`,JSON.stringify(payload),this.httpOptions)
      .pipe(catchError((error: any) => throwError(error => error)));
  }
}
